export const StandardPlus = [
  { key: 1, text: 'SPGW001', value: 'SPGW001' },
  { key: 2, text: 'SPGW011', value: 'SPGW011' },
  { key: 3, text: 'SPGW002', value: 'SPGW002' },
  { key: 4, text: 'SPGW012', value: 'SPGW012' },
]

export const Standard = [
  { key: 1, text: 'SPGW101', value: 'SPGW101' },
  { key: 2, text: 'SPGW111', value: 'SPGW111' },
  { key: 3, text: 'SPGW102', value: 'SPGW102' },
  { key: 4, text: 'SPGW112', value: 'SPGW112' },
]

export const Fixed = [
  { key: 1, text: 'SPGW200', value: 'SPGW200' },
  { key: 2, text: 'SPGW201', value: 'SPGW201' },
  { key: 3, text: 'SPGW202', value: 'SPGW202' },
]

export const Moving = [
  { key: 1, text: 'SPGW301', value: 'SPGW301' },
  { key: 2, text: 'SPGW311', value: 'SPGW311' },
  { key: 3, text: 'SPGW302', value: 'SPGW302' },
  { key: 4, text: 'SPGW312', value: 'SPGW312' },
]

export const SKU = [
  { key: 1, text: 'SCTHL-01', value: 'SCTHL-01' },
  { key: 2, text: 'SCTH-01', value: 'SCTH-01' },
  { key: 3, text: 'SCTHD-01', value: 'SCTHD-01' },
  { key: 4, text: 'SCDS-01', value: 'SCDS-01' },
  { key: 5, text: 'SCTHB-01', value: 'SCTHB-01' },
  { key: 6, text: 'SCDB-01', value: 'SCDB-01' },
  { key: 7, text: 'SCCH-01', value: 'SCCH-01' },
  { key: 8, text: 'SCRF-01', value: 'SCRF-01' },
]
